import type { EmptyStateWithoutCardProps } from '@hivebrite/design-system/SimpleCard';
import { EmptyStateWithoutCard } from '@hivebrite/design-system/SimpleCard';

type EmptyStateMentoringProps = Pick<
  EmptyStateWithoutCardProps,
  'description' | 'title' | 'faIconProps' | 'buttonProps'
>;

const EmptyStateMentoring = ({
  description,
  title,
  faIconProps = { iconName: 'telescope' },
  buttonProps,
}: EmptyStateMentoringProps) => (
  <EmptyStateWithoutCard
    title={title}
    description={description}
    faIconProps={faIconProps}
    buttonProps={buttonProps}
  />
);

export default EmptyStateMentoring;
